import React, { useEffect, useState } from 'react';
import axios from 'axios';

const NomineeDrawnCards = ({ distCode, afsoCode }) => {
  const [data, setData] = useState([]);
  
  useEffect(() => {

axios.get(`${process.env.REACT_APP_URL}/api/nominee/drawn`, {   
       params: { distCode, afsoCode}
    })
    .then(res => setData(res.data))
    .catch(() => setData([]));
  }, [distCode, afsoCode]);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      {data.length > 0 ? (
        <table border="1" align="center" width="60%">
          <thead>
            <tr className="tableheader">
              <th colSpan="5">Nominee Drawn Cards List</th>
            </tr>
            <tr className="tableheader">
              <th>Sl.No</th>
              <th>RC No</th>
              <th>Nominee Name</th>
              <th>Nominee Mobile</th>
              <th>Avail Time</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.rcId}</td>
                <td>{item.nomName}</td>
                <td>{item.nomMobile}</td>
                <td>{item.transDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="response">Details Not Found</div>
      )}
    </div>
  );
};

export default NomineeDrawnCards;
